import { render, staticRenderFns } from "./DashboardOverviewAgent.vue?vue&type=template&id=656f4003&scoped=true"
import script from "./DashboardOverviewAgent.vue?vue&type=script&lang=js"
export * from "./DashboardOverviewAgent.vue?vue&type=script&lang=js"
import style0 from "./DashboardOverviewAgent.vue?vue&type=style&index=0&id=656f4003&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f4003",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656f4003')) {
      api.createRecord('656f4003', component.options)
    } else {
      api.reload('656f4003', component.options)
    }
    module.hot.accept("./DashboardOverviewAgent.vue?vue&type=template&id=656f4003&scoped=true", function () {
      api.rerender('656f4003', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/dashboard/components/DashboardOverviewAgent.vue"
export default component.exports